import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import PhoneInput from 'react-phone-number-input'
import FormError from '@components/FormError'
import Input from '@components/Input'
import useStyles from './styles'
import { ReactComponent as TickIcon } from 'src/images/tick.svg'
import { ErrorMessage } from '@components/ErrorMessage/ErrorMessage'
import Spinner from '@components/Spinner'
import { TEST_IDS } from 'src/constants/testIds'
import { usePhoneInput } from './usePhoneInput'

export const OldPatientPhoneInput = (props: ReturnType<typeof usePhoneInput>) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const benefits = [
    t('old_patient_verification_page_benefits_1'),
    t('old_patient_verification_page_benefits_2'),
    t('old_patient_verification_page_benefits_3'),
  ]

  return (
    <>
      {props.isLoading && <Spinner showOverlay size="large" />}
      <div className={classes.root}>
        <div className={classes.container}>
          <span className={classes.text}>{t('old_patient_verification_page_text')}</span>
          {props.error && (
            <div className={classes.errorContainer}>
              <ErrorMessage message={t(props.error)} />
            </div>
          )}
          <form onSubmit={props.handleSubmit(props.onSubmit)} className={classes.form}>
            <div className={classes.phoneInput}>
              <Controller
                control={props.control}
                name="phone"
                defaultValue=""
                render={({ field }) => (
                  <>
                    <PhoneInput
                      international
                      inputComponent={Input}
                      defaultCountry="DE"
                      country="DE"
                      placeholder={t('phone')}
                      value={field.value}
                      onChange={(value) => field.onChange(value || '')}
                      required
                      type="tel"
                      autoComplete="tel"
                      className={classes.phoneInput}
                      data-test={TEST_IDS.phoneInput}
                    />
                    {props.errors.phone && <FormError message={props.errors.phone.message} />}
                  </>
                )}
              />
            </div>
          </form>
          <span className={classes.benefitsHeader}>{t('old_patient_verification_page_benefits_headline')}</span>
          <div className={classes.benefits}>
            {benefits.map((benefit) => (
              <div className={classes.benefit} key={benefit}>
                <div className={classes.benefitIcon}>
                  <TickIcon />
                </div>
                <div>{benefit}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
